import { firebaseRecursosRepository } from '../../infrastructure/recursos/firebaseRecurso.repository'

export const deleteRecurso = recurso => firebaseRecursosRepository.eliminarRecurso(recurso)
